import {createLogger} from 'redux-logger';

export const logger = createLogger({
  titleFormatter: (action: any) => {
    if (action.meta?.arg?.type === 'query') {
      const {
        arg: {endpointName = ''},
        requestStatus,
      } = action.meta;
      return `action: query ${endpointName} | ${requestStatus.toUpperCase()}`;
    } else {
      return action.type;
    }
  },
});
